<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on: tooltip }">
        <v-btn
          outlined
          x-small
          fab
          class="mr-2 mt-8"
          v-on:click="onSearch"
          v-on="tooltip"
        >
          <v-icon small>mdi-magnify</v-icon>
        </v-btn>
      </template>
      <span>{{ $t("Find") }}</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on: tooltip }">
        <v-btn
          outlined
          x-small
          fab
          class="mr-3 mt-8"
          v-on:click="onClear"
          v-on="tooltip"
        >
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </template>
      <span>{{ $t("ClearFilters") }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  methods: {
    onClear() {
      this.$emit('clear');
    },
    onSearch() {
      this.$emit('get');
    },
  },
};
</script>
